<template>
  <v-row class="mt-0 py-0 mb-1">
    <v-col cols="12" :sm="4" class="py-0">
      <v-text-field
        class="col-12 col-sm-4"
        style="padding: 0"
        outlined
        v-model="nameF"
        label="Фамилия"
        :readonly="config.readonly || false"
        :error="nameF.length == 0"
        :error-messages="error"
        :disabled="disabled"
        :hide-details="config.hideDetails || false"
        :dense="config.dense || false"
        :class="model.class || config.class"
      />
    </v-col>
    <v-col cols="12" :sm="4" class="py-0">
      <v-text-field
        class="col-12 col-sm-4"
        outlined
        v-model="nameI"
        label="Имя"
        :error="nameI.length != 0 && nameF.length == 0"
        :error-messages="nameI.length != 0 && nameF.length == 0 ? 'Имя не будет сохранено' : ''"
        :readonly="config.readonly || false"
        :disabled="disabled || !nameF"
        :hide-details="config.hideDetails || false"
        :dense="config.dense || false"
        :class="model.class || config.class"
      />
    </v-col>
    <v-col cols="12" :sm="4" class="py-0">
      <v-text-field
        class="col-12 col-sm-4"
        outlined
        v-model="nameO"
        label="Отчество"
        :error="nameO.length != 0 && nameI.length == 0"
        :error-messages="nameO.length != 0 && nameI.length == 0 ? 'Отчество не будет сохранено' : ''"
        :readonly="config.readonly || false"
        :disabled="disabled || !nameI"
        :hide-details="config.hideDetails || false"
        :dense="config.dense || false"
        :class="model.class || config.class"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: [String],
    model: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    config: { type: Object, default: {} },
  },
  data() {
    return {
      name: ["", "", ""],
    };
  },
  watch: {
    fullName(v) {
      //let name = v ? v.split(" ") || ["", "", ""] : ["", "", ""];
      let name = (v ?? "").split(" ").concat(["", "", ""]).slice(0, 3);
      this.name = [...name];
    },
  },
  created() {},
  mounted() {},
  destroyed() {},
  updated() {},
  computed: {
    fullName: {
      get() {
        return (this.value || "").trim();
      },
      set(v) {
        this.$emit("input", v);
      },
    },
    nameF: {
      get() {
        let name;
        try {
          name = this.fullName.split(" ");
        } catch (error) {
          name = [];
        }
        this.name[0] = name[0];
        return name[0] || "";
      },
      set(v) {
        this.fio(0, v);
      },
    },
    nameI: {
      get() {
        let name;
        try {
          name = this.fullName.split(" ");
        } catch (error) {
          name = [];
        }
        this.name[1] = name[1];
        return name[1] || "";
      },
      set(v) {
        this.fio(1, v);
      },
    },
    nameO: {
      get() {
        let name;
        try {
          name = this.fullName.split(" ");
        } catch (error) {
          name = [];
        }
        this.name[2] = name[2];
        return name[2] || "";
      },
      set(v) {
        this.fio(2, v);
      },
    },
  },
  methods: {
    fio(n, v) {
      this.name[n] = v.trim().replace(" ", "");
      let name = "";

      this.name.forEach((el) => {
        //  name = el.trim() ? name + " " + el.trim() : name;
        name = name + " " + (el || "").trim();
      });
      this.fullName = name.trim();
    },
  },
};
</script>
